module.exports = __webpack_public_path__ + "static/media/delivery-truck.336f8d6b.png";